class AutocompleteAddress {

  constructor(fieldId, containerId, bounds) {
    this._fieldId = fieldId;
    this._containerId = containerId;
    this._bounds = bounds;

    this._typingTimer = null;
    this._previousQuery = '';
    this._resultContainer = null;
    this._inputField = null;
    this._preventCall = 0;
    this._currentSelection = -1;
    this._streets = [];
    this._coordstoZoom = null;
    this._navInProgress= false;

    this.initialize();
  }

  initialize() {
    this._inputField = document.getElementById(this._fieldId);

    this._resultContainer = document.createElement('div');
    this._resultContainer.id = this._containerId;
    this._resultContainer.className = 'map-search-bar-form__autocomplete';
    this._resultContainer.style = "display:none;";

    this._inputField.parentNode.parentNode.insertBefore(
      this._resultContainer,
      this._inputField.parentNode.nextSibling
    );

    this.initEvents();
  }

  initEvents() {
    var thisObj = this;

    this._inputField.addEventListener('keyup', function(e) {
      thisObj._streets= [];

      //si le texte a plus de caractères et qu'on navigue pas avec les flèches dans les résultats
      if (this.value.length >= 3 && !thisObj._navInProgress && e.code !== "Enter") {
        if (thisObj._typingTimer) {
          clearTimeout(thisObj._typingTimer);
        }

        thisObj._currentSelection = -1;
        thisObj._typingTimer = setTimeout(function(){
          thisObj.autocompletion();
        }, 200);
      }
    });

    this._inputField.addEventListener('keydown', function(e) {
      clearTimeout(thisObj._typingTimer);

      switch(e.keyCode) {
        case 9:
          $("#" + thisObj._resultContainer.id).hide();
          thisObj._navInProgress = false;
          CustomEvents.dispatchEvent('eventGoToAddress');
          break;
        case 38:
          thisObj.navigateKeyboard('up');
          //$("#" + thisObj._inputField.id).val($(".autoSelect", '#' + thisObj._resultContainer.id).find("div .selectable.hovered").text());
          break;
        case 40:
          thisObj.navigateKeyboard('down');
          //$("#" + thisObj._inputField.id).val($(".autoSelect", '#' + thisObj._resultContainer.id).find("div .selectable.hovered").text());
          break;
        case 13:
          e.preventDefault();
          thisObj._navInProgress = false;
          $("#" + thisObj._resultContainer.id).hide();
          CustomEvents.dispatchEvent('eventGoToAddress');
          break;
        default :
          $("#" + thisObj._resultContainer.id).find("div .selectable").removeClass("hovered");
          break;
      }
    });

    this._inputField.addEventListener('click', function(e){
      e.stopPropagation();
      thisObj._streets= [];

      $(".autocompleteAdresses", '#' + thisObj._resultContainer.id).remove();
      $("#" + thisObj._resultContainer.id).show();

      thisObj._resultContainer.innerHTML = "<ul class='autoSelect'></ul>";
    });

    //masquage des résultats si click en dehors du champ
    $(document).on('mouseup', function(e) {
      if(e.target.id !== thisObj._inputField.id) {
        $("#" + thisObj._resultContainer.id).hide();
      }
    });
  }

  /**
   * Gestion de la navigation up/down dans les résultats
   */
  navigateKeyboard(direction) {
    this._navInProgress = true;

    if (direction === 'up') {
      if (this._currentSelection > 0) {
        this._currentSelection -= 1;
      }
      else {
        this._currentSelection = $(".autoSelect", '#' + this._resultContainer.id).find('.selectable').length-1;
      }
    }
    if (direction === 'down') {
      if (this._currentSelection < $(".autoSelect", '#' + this._resultContainer.id).find('.selectable').length-1) {
        this._currentSelection += 1;
      }
      else {
        this._currentSelection = 0;
      }
    }

    $(".autoSelect", '#' + this._resultContainer.id).find('.selectable').removeClass("hovered");
    $(".autoSelect", '#' + this._resultContainer.id).find('.selectable').eq(this._currentSelection).addClass("hovered");

    var currentLineAddress = $(".autoSelect", '#' + this._resultContainer.id).find('.selectable').eq(this._currentSelection);
    var labelAddress = currentLineAddress.find("span").text();
    $('#' + this._inputField.id).val(labelAddress);

    if (typeof currentLineAddress.data('longitude') !== "undefined" && typeof currentLineAddress.data('latitude') !== "undefined") {
      this._coordstoZoom = {'libelle': labelAddress, 'lng':currentLineAddress.data('longitude'), 'lat': currentLineAddress.data('latitude')};
    }
    else {
      this._coordstoZoom = null;
    }
  }

  autocompletion() {
    var query = this._inputField.value;
    var thisObj = this;

    if (query !== "" && query !== this._previousQuery) {
      this._previousQuery = query;

      //Affichage du bloc des résultats
      $("#" + thisObj._resultContainer.id).show();

      Geocoder.geocode(query, function(predictions) {

        //suppression de l'ancien bloc de résultats photon
        if ($(".autocompleteAdresses", '#' + thisObj._resultContainer.id).length) {
          $(".autocompleteAdresses", '#' + thisObj._resultContainer.id).remove();
        }

        $(".autoSelect", '#' + thisObj._resultContainer.id).append("<div class='autocompleteAdresses'></div>");

        var formatAddress = "";
        var place = [];
        var line = '';
        var i;

        var length = predictions.data.features.length;
        for (i = 0; i < length; i++) {
          var prediction = predictions.data.features[i];

          //Afin d'éviter les doublons
          formatAddress = Geocoder.formatAddress(prediction.properties);

          if (!thisObj._streets[formatAddress]) {
            thisObj._streets[formatAddress] = 1;

            place = prediction.geometry.coordinates;

            //test si l'adresse est dans les limites définies
            if (Utils.inBounds({lng:place[0], lat:place[1]}, thisObj._bounds)) {

              line = '<li class="selectable" data-type="autocomplete-address" ' +
                'data-latitude="' + place[1] + '" data-longitude="' + place[0] + '">' +
                  "<span class='icon-address'></span>" +
                  "<span>" + formatAddress + "</span>" +
              '</li>';

              //ajout de la ligne dans le bloc des résultats
              $(".autocompleteAdresses", '#' + thisObj._resultContainer.id).append(line);
            }
          }
        }

        //vidage du tableau une fois la liste des adresses construites
        thisObj._streets = [];

        //ajout de l'évènement click sur les lignes de résultats
        $(".autocompleteAdresses .selectable", '#' + thisObj._resultContainer.id).click(function() {
          $('#' + thisObj._inputField.id).val($(this).find("span").text());
          $('#' + thisObj._resultContainer.id).hide();
          thisObj._coordstoZoom = {'libelle': $(this).find("span").text(), 'lng':$(this).data('longitude'), 'lat': $(this).data('latitude')};
          thisObj._navInProgress = false;

          CustomEvents.dispatchEvent('eventGoToAddress');
        });
      });
    }
  }

  getCoordsToZoom() {
    return this._coordstoZoom;
  }

  setCoordsToZoom(coordstoZoom) {
    this._coordstoZoom = coordstoZoom;
  }

  getAddress() {
    return this._inputField.value;
  }
}
